import { DocumentationPageV2 } from "../elements";
import { DesignElementSnapshotBase, pickLatestSnapshots } from "./base";
import { z } from "zod";
/**
 * Snapshot of a documentation page.
 *
 * Please note that existence of snapshot's references (including parent persistent id) is not guaranteed.
 */
export const DocumentationPageSnapshot = DesignElementSnapshotBase.extend({
    page: DocumentationPageV2,
    pageContentHash: z.string(),
    pageContentStorageKey: z.string(),
});
//
// Util functions
//
export function pickLatestPageSnapshots(snapshots) {
    return pickLatestSnapshots(snapshots, (s) => s.page.id);
}
